import {
  fetchTransferStart,
  fetchTransferSuccess,
  fetchTransferFailure,
} from "./reducer";

import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";

import { GET_ALL_TRANSFER } from "../../constants/constants";

export const getAllTransfer =
  (first = 0, offset = 10, types = "", setLoading) =>
  async (dispatch) => {
    try {
      setLoading?.(true);

      dispatch(fetchTransferStart());

      const response = await determineBaseUrlAndPerformApiCall(
        GET_ALL_TRANSFER(first, offset, types),
        "GET",
      );

      dispatch(fetchTransferSuccess(response));

      setLoading?.(false);
    } catch (error) {
      setLoading?.(false);

      dispatch(fetchTransferFailure(error.message));
    }
  };
